import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import IconCheckbox from '../../../../../../components/icon-checkbox';
import { TimerIcon } from '../../../../../../resource/icons';
import { onlyActiveSelector } from '../../../../store/selectors';
import { setFilterState } from '../../../../store/actions';
import { filterNames } from '../../../../constants/common';

const OnlyActiveCheckbox = () => {
  const dispatch = useDispatch();
  const onlyActive = useSelector(onlyActiveSelector);

  const handleChange = (value) => {
    dispatch(setFilterState({ filterName: filterNames.onlyActive, value }));
  };

  return (
    <IconCheckbox
      icon={<TimerIcon />}
      value={onlyActive}
      onChange={handleChange}
    >
      Активные
    </IconCheckbox>
  );
};

export default OnlyActiveCheckbox;
